// VCFViewer.js
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import VCard from './VCard';
import NoVCardSelected from './NoVCardSelected'; // Import new component
import VCardDownloader from './VCardDownloader.tsx';
import { fetchVcfData } from "../actions/index.ts";

const VCFViewer = ({ filename }) => {
    const dispatch = useDispatch();
    const vcfData = useSelector(state => state.vcfData.vcards);
    const loading = useSelector(state => state.vcfData.loading);
    const error = useSelector(state => state.vcfData.error);

    useEffect(() => {
        dispatch(fetchVcfData(filename));
    }, [filename, dispatch]);

    if (loading) return <p>Fetching VCF data...</p>;
    if (error) {
        if (!filename || filename === "default.vcf")
            return <NoVCardSelected errorMessage={"Please select a vCard to display the information."} />
        else
            return <NoVCardSelected errorMessage={"A network error occurred. Maybe the requested file '" + filename + "' is not available."} />;
    }

    return (
        <div>
            {
                vcfData && vcfData.length > 0 ?
                    vcfData.map((contact, index) => {
                        // Generate a stable unique key from contact data
                        // Remove whitespaces and special characters for a valid React key
                        const nameKey = contact.fn?.value?.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '');
                        const emailKey = contact.email?.[0]?.value?.replace(/[^a-zA-Z0-9@.-]/g, '');
                        const telKey = contact.tel?.[0]?.value?.replace(/[^0-9+]/g, '');
                        const contactKey = nameKey || emailKey || telKey || `contact-${index}`;

                        return (
                            <div key={contactKey}>
                                <VCard contact={contact} />
                                <VCardDownloader filename={filename} vCardData={vcfData} />
                            </div>
                        );
                    }) :
                    <NoVCardSelected errorMessage={"The received VCF file contains no valid VCF data."} />
            }
        </div>
    );
};

export default VCFViewer;